/* Cart presentation consumes the existing quote/calendar; it never changes rates. */
(function () {
  'use strict';
  if (window.dsrcvCartDeliveryPresentation) return;
  var queued = false;
  function cartKey() {
    var drawer = document.getElementById('sidebar-cart');
    if (!drawer) return '';
    return [drawer.getAttribute('data-native-ucd-has-pre-order'), drawer.getAttribute('data-native-ucd-has-non-pre-order')].concat(
      Array.prototype.map.call(drawer.querySelectorAll('[data-native-ucd-line-quantity]'), function (input) {
        var item = input.closest('.NativeUcdCartItem');
        return input.getAttribute('data-line-id') + ':' + input.value + ':' +
          (item && item.getAttribute('data-native-ucd-line-properties') || '');
      }).sort()).join('|');
  }
  var quoteKey = cartKey();
  var rateKey = quoteKey;
  var knownCartKey = quoteKey;
  var waitingForRefresh = false;
  var receiptChangePending = false, receiptRefreshTimer = null, lastRefreshedReceipt = null;
  function reconcileIdentity() {
    var key = cartKey();
    if (key !== knownCartKey) {
      knownCartKey = key;
      quoteKey = null;
      rateKey = null;
      // Drawer replacement precedes the shared cart refresh event. An older
      // in-flight response in that gap must not acquire the new basket key.
      waitingForRefresh = true;
    }
    return key;
  }
  function text(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }
  function deliveryInformation(node) {
    // Campaign themes already supply their own dispatch explanation.
    if (!node || node.closest('details')) return node;
    var details = document.createElement('details'), summary = document.createElement('summary');
    var label = document.createElement('span'), icon = document.createElement('span'), note = document.createElement('p');
    details.setAttribute('data-cart-delivery-information', '');
    details.className = node.className;
    details.style.cssText = 'margin:4px 0 0;font-size:11px;line-height:1.4';
    summary.style.cssText = 'display:inline-flex;align-items:center;gap:5px;list-style:none;cursor:pointer';
    label.setAttribute('data-cart-delivery-estimate', '');
    label.textContent = node.textContent;
    icon.textContent = 'ⓘ';
    icon.setAttribute('aria-hidden', 'true');
    note.textContent = 'Delivery time starts after despatch and depends on the delivery service selected at checkout.';
    note.style.cssText = 'margin:6px 0 0;padding:8px 10px;background:#f5f5f5;border-radius:4px;font-size:11px;line-height:1.4';
    summary.append(label, icon);
    details.append(summary, note);
    node.replaceWith(details);
    return label;
  }
  function current(value, context) {
    return value && value.countryCode === context.country && value.currency === context.currency &&
      value.subtotalCents === context.subtotal;
  }
  function formatCents(cents, currency) {
    try {
      var fractionDigits = cents % 100 === 0 ? 0 : 2;
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency', currencyDisplay: 'narrowSymbol', currency: currency,
        minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits
      }).format(cents / 100);
    } catch (error) {
      return currency + ' ' + (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2);
    }
  }
  function transit(label) {
    var value = String(label || '')
      .replace(/\s+-\s+(?:Pre-order Items Ship On Their Listed Date|Ships When Pre-orders Are In Stock)\s*$/i, '')
      .replace(/\s*\(No Import Charges On Delivery\)\s*$/i, '')
      .replace(/^\s*Standard Shipping\s*\|\s*/i, '').trim();
    if (/^(?:Delivered )?Next Day(?: Once Dispatched)?$/i.test(value)) return '1 working day';
    var match = value.match(/^(\d+)(?:\s*[-–]\s*(\d+)|(\+))?\s+(working\s+|business\s+)?days?$/i);
    if (!match) return '';
    var min = Number(match[1]), max = Number(match[2] || match[1]);
    if (!Number.isSafeInteger(min) || !Number.isSafeInteger(max) || min < 1 || max < min || max > 365) return '';
    return (match[3] ? min + '+' : min === max ? String(min) : min + '–' + max) + ' ' +
      (match[4] ? match[4].toLowerCase() : '') + (max === 1 && !match[3] ? 'day' : 'days');
  }
  function render() {
    queued = false;
    var drawer = document.getElementById('sidebar-cart');
    var totals = drawer && drawer.querySelector('[data-native-ucd-merchandise-total]');
    if (!totals) return;
    var context = { country: String(window.Shopify && window.Shopify.country || '').toUpperCase(),
      currency: String(window.Shopify && window.Shopify.currency && window.Shopify.currency.active || '').toUpperCase(),
      subtotal: Number(totals.getAttribute('data-native-ucd-merchandise-total')) };
    var key = reconcileIdentity();
    var valid = /^[A-Z]{2}$/.test(context.country) && /^[A-Z]{3}$/.test(context.currency) &&
      Number.isSafeInteger(context.subtotal) && context.subtotal >= 0;
    var api = window.__FreeShippingBarAPI;
    var quote = api && api.getQuote();
    var fallback = window.dsrcvCartDutiesPreview && window.dsrcvCartDutiesPreview.getCheckoutFallback && window.dsrcvCartDutiesPreview.getCheckoutFallback();
    var checkoutFallback = fallback && fallback.country === context.country && fallback.currency === context.currency;
    var shipping = window.dsrcvCartShipping && window.dsrcvCartShipping.getState();
    var rate = valid && rateKey === key && shipping && shipping.status === 'available' && current(shipping.rate, context) &&
      Number.isSafeInteger(shipping.rate.priceCents) && shipping.rate.priceCents >= 0 ? shipping.rate : null;
    var quoteCurrent = valid && quoteKey === key && current(quote, context) && quote.available === true &&
      Number.isSafeInteger(quote.priceCents) && quote.priceCents >= 0 && quote.isFree === (quote.priceCents === 0) &&
      !(api.isLoading && api.isLoading());
    var progressData = api && typeof api.getProgress === 'function' ? api.getProgress() : null;
    var progressCurrent = valid && quoteKey === key && current(progressData, context) && progressData.available === true &&
      Number.isSafeInteger(progressData.freeThresholdCents) && progressData.freeThresholdCents >= 0 &&
      Number.isSafeInteger(progressData.remainingCents) &&
      progressData.remainingCents === Math.max(0, progressData.freeThresholdCents - context.subtotal) &&
      progressData.thresholdReached === (context.subtotal >= progressData.freeThresholdCents) &&
      typeof progressData.methodLabel === 'string' && typeof progressData.rulesVersion === 'string' &&
      ['shopify_native_free_rate_transition', 'canonical_shop_currency_quote'].indexOf(progressData.source) !== -1 &&
      (progressData.source !== 'shopify_native_free_rate_transition' ||
        typeof progressData.expiresAt === 'string' && Date.parse(progressData.expiresAt) > Date.now());
    var loading = api && (api.isLoading && api.isLoading() || api.isProgressLoading && api.isProgressLoading());
    var terminal = shipping && ['error', 'no_rates', 'selection_required', 'currency_unavailable', 'checkout_required'].indexOf(shipping.status) !== -1;
    var unavailableProgress = shipping && shipping.status === 'selection_required' ? 'Choose a delivery service' : 'Delivery estimate unavailable';
    var progress = rate ? (rate.priceCents === 0 ? 'Free delivery unlocked' : 'Delivery available') : unavailableProgress;
    if (rate && rate.priceCents === 0) progress = 'Free delivery unlocked';
    else if (progressCurrent && progressData.thresholdReached) {
      if (rate && rate.priceCents === 0) progress = 'Free delivery unlocked';
      else if (shipping && shipping.status === 'pending' || api && api.isProgressLoading && api.isProgressLoading()) progress = 'Checking free delivery…';
    } else if (quoteCurrent && quote.isFree && rate && rate.priceCents === 0) {
      progress = 'Free delivery unlocked';
    } else if (progressCurrent && progressData.remainingCents > 0) {
      progress = 'Add ' + formatCents(Math.ceil(progressData.remainingCents / 100) * 100, context.currency) + ' for free delivery';
    } else if (terminal && !waitingForRefresh && !loading) progress = unavailableProgress;
    else if (!valid || quoteKey !== key || loading) progress = 'Checking free delivery…';
    if (checkoutFallback && !rate && !(progressCurrent && progressData.remainingCents > 0)) progress = 'Delivery calculated at checkout';
    text(drawer.querySelector('[data-cart-delivery-progress]'), progress);

    var preorder = drawer.getAttribute('data-native-ucd-has-pre-order') === 'true';
    var stock = drawer.getAttribute('data-native-ucd-has-non-pre-order') === 'true';
    var preorderLines = drawer.querySelectorAll('.NativeUcdCartItem--preOrder');
    var allPreorderDatesVisible = preorderLines.length > 0 && Array.prototype.every.call(preorderLines, function (line) {
      var date = line.querySelector('[data-native-ucd-preorder-date]');
      return date && !date.hidden && date.textContent.trim() !== '';
    });
    var redundantPreorderSummary = preorder && !stock && context.country === 'GB' && allPreorderDatesVisible;
    var estimate = rate && typeof window.dsrcvGetCartDeliveryEstimate === 'function'
      ? window.dsrcvGetCartDeliveryEstimate(context.country, context.subtotal, rate) : '';
    if (!estimate && rate && !(preorder && context.country === 'GB' && !stock)) {
      var windowLabel = transit(rate.methodLabel);
      if (!windowLabel && quoteCurrent && String(quote.methodLabel).toLowerCase() === String(rate.methodLabel).toLowerCase()) {
        windowLabel = transit(quote.transitWindowLabel);
      }
      if (windowLabel) estimate = (preorder && context.country === 'GB' ? 'In-stock: ' : '') +
        'Estimated delivery ' + windowLabel + ' after despatch';
    }
    if (preorder && context.country === 'GB') {
      estimate = stock ? (estimate ? estimate + ' · pre-orders on listed dates' : 'Pre-orders on listed dates')
        : 'Pre-orders: see item despatch dates';
    } else if (preorder) {
      estimate = estimate ? estimate + ' · despatched together when all items are ready' : 'Despatched together when all items are ready';
    }
    if (!estimate) estimate = shipping && shipping.status === 'pending' ? 'Checking delivery estimate…' : '';
    // Error/retry and service selection have their own existing row.
    var failed = shipping && ['error', 'no_rates', 'selection_required', 'currency_unavailable', 'checkout_required'].indexOf(shipping.status) !== -1;
    var node = drawer.querySelector('[data-cart-delivery-estimate]');
    if (rate && estimate) node = deliveryInformation(node);
    text(node, redundantPreorderSummary || failed && !preorder ? '' : estimate);
    if (node) node.hidden = !estimate || redundantPreorderSummary || failed && !preorder;
    var information = node && node.closest('[data-cart-delivery-information]');
    if (information) {
      information.hidden = node.hidden;
      information.querySelector('summary').setAttribute('aria-label', node.textContent + '. Delivery information');
      text(information.querySelector('p'), /^Estimated arrival\b/.test(estimate)
        ? 'Arrival dates are estimates and allow for weekends and public holidays.'
        : 'Delivery time starts after despatch and depends on the delivery service selected at checkout.');
    }
  }
  function schedule() {
    if (queued) return;
    queued = true;
    Promise.resolve().then(render);
  }
  window.dsrcvCartDeliveryPresentation = { render: schedule };
  document.addEventListener('dsrcv:shipping-quote-updated', function () { var key = reconcileIdentity(); if (!waitingForRefresh) quoteKey = key; schedule(); });
  document.addEventListener('dsrcv:cart-shipping-updated', function () { var key = reconcileIdentity(); if (!waitingForRefresh) rateKey = key; schedule(); });
  document.addEventListener('dsrcv:delivery-promise:rendered', schedule);
  ['cart:change', 'cart:refresh', 'cart:updated', 'cart:request:success', 'product:added', 'native-ucd:product-added', 'currency:change', 'covCurrency:updated', 'country:change'].forEach(function (event) {
    document.addEventListener(event, function () {
      window.clearTimeout(receiptRefreshTimer); receiptRefreshTimer = null;
      reconcileIdentity(); waitingForRefresh = false; quoteKey = null; rateKey = null;
      var drawer = document.getElementById('sidebar-cart');
      lastRefreshedReceipt = drawer && drawer.querySelector('[data-native-ucd-merchandise-total]');
      schedule();
    });
  });
  window.addEventListener('change', function (event) {
    if (!event.target.matches('[data-native-ucd-line-quantity], [data-native-ucd-line-variant]')) return;
    reconcileIdentity();
    waitingForRefresh = true;
    receiptChangePending = true;
    window.clearTimeout(receiptRefreshTimer); receiptRefreshTimer = null;
    quoteKey = null;
    rateKey = null;
    // Fence the banner's old threshold response at input intent, before the
    // native shipping adapter publishes its pending state and before legacy
    // change handlers can stop propagation. The banner waits for cart:refresh
    // before requesting progress again, so it cannot read the old basket.
    document.dispatchEvent(new CustomEvent('dsrcv:delivery-progress-invalidated'));
    var shipping = window.dsrcvCartShipping;
    if (shipping && typeof shipping.invalidate === 'function') shipping.invalidate();
    schedule();
  }, true);
  function start() {
    var drawer = document.getElementById('sidebar-cart');
    if (drawer) new MutationObserver(function (records) {
      var receiptReplaced = records.some(function (record) {
        return record.type === 'childList' && Array.prototype.some.call(record.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches('[data-native-ucd-merchandise-total]') ||
            node.querySelector('[data-native-ucd-merchandise-total]'));
        });
      });
      if (receiptReplaced) {
        reconcileIdentity();
        var receipt = drawer.querySelector('[data-native-ucd-merchandise-total]');
        if (waitingForRefresh || receiptChangePending && receipt !== lastRefreshedReceipt) {
          // Native cart:refresh can precede its replacement HTML. Start fresh
          // producer generations after that receipt arrives; late old quotes
          // must still be cancelled rather than assigned to the new lines.
          var key = cartKey();
          window.clearTimeout(receiptRefreshTimer);
          receiptRefreshTimer = window.setTimeout(function () {
            receiptRefreshTimer = null;
            if (cartKey() === key && drawer.querySelector('[data-native-ucd-merchandise-total]') === receipt)
              document.dispatchEvent(new CustomEvent('cart:updated'));
          }, 200);
        }
        receiptChangePending = false;
      }
      if (records.some(function (record) {
        if (record.type === 'attributes') return true;
        return Array.prototype.some.call(record.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches('[data-cart-delivery-progress], [data-cart-delivery-estimate], [data-native-ucd-merchandise-total]') ||
            node.querySelector('[data-cart-delivery-progress], [data-cart-delivery-estimate], [data-native-ucd-merchandise-total]'));
        });
      })) schedule();
    }).observe(drawer, { childList: true, subtree: true, attributes: true,
      attributeFilter: ['data-native-ucd-line-properties', 'data-native-ucd-has-pre-order', 'data-native-ucd-has-non-pre-order'] });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
